import { AnnouncementFormPage } from './AnnouncementFormPage';
export default AnnouncementFormPage;
